import React from "react";
// import { ProgressBar } from "react-bootstrap";
// import Rating from "react-rating";
import axios from "axios";
import { useState, useEffect } from "react";
import { environment } from "../../environment";
import { useHistory } from "react-router-dom";
import Loader from "../Components/Loader";
import withReactContent from "sweetalert2-react-content";
import { Button, Col, Row, Tab, Tabs, Form, InputGroup } from "react-bootstrap";
import { Stack } from "@mui/material";
import { faEye, faEyeSlash } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import Swal from "sweetalert2";
import "./CustomerDashboard.css";

const MySwal = withReactContent(Swal);

const UserProfile = () => {
  const { push } = useHistory();
  // var dap_storedDetails;
  // let dap_responseData;
  let image_url = "../../assets/images/DAP_logo1.png";
  let userDetails;
  const [loader, setLoader] = useState(true);
  const [dap_profilePicUrl, setProfilePicUrl] = useState("");
  const [dap_userDetails, setUserDetails] = useState({
    name: "",
    email: "",
    authority: "",
    address: "",
  });
  const [dap_mobile, setMobile] = useState("");
  const [dap_address, setAddress] = useState("");
  const [key, setKey] = useState("Profile");
  const [userInfo, setUserInfo] = useState({
    address: "",
    city: "",
    country: "",
    email: "",
    state: "",
    userFirstName: "",
    userId: "",
    userLastName: "",
    userName: "",
    userNumber: "",
    zip: "",
    isBilable: false,
    package:"",
    joindate:"",
    organization:"",
  });
  const [currentPassword, setCurrentPassword] = useState("");
  const [newPassword, setNewPassword] = useState("");
  const [confirmPassword, setConfirmPassword] = useState("");
  const [showCurrentPassword, setShowCurrentPassword] = useState(false);
  const [showNewPassword, setShowNewPassword] = useState(false);
  const [showConfirmPassword, setShowConfirmPassword] = useState(false);
  const [greeting, setGreeting] = useState("");
  const [textareaValue, setTextareaValue] = useState("");

  const handleTextareaChange = (event) => {
    setTextareaValue(event.target.value);
  };
  const sendmail = () => {
    if (textareaValue != "") {
      axios
        .post(environment.dap_url + "sendmail", {
          content: textareaValue,
        })
        .then((res) => {
          MySwal.fire({
            title: <p>Mail sent</p>,
            type: "success",
          });
          setTextareaValue("");
        })
        .catch((err) => {
          MySwal.fire({
            title: <p>{err?.response?.data?.message || "Failed"}</p>,
            type: "error",
          });
        });
    } else {
      MySwal.fire({
        title: <p>Please Write About Yours Expereience</p>,
        type: "success",
      });
    }
  };
  const togglePasswordVisibility = (field) => {
    if (field === "currentPassword") {
      setShowCurrentPassword(!showCurrentPassword);
    } else if (field === "newPassword") {
      setShowNewPassword(!showNewPassword);
    } else if (field === "confirmPassword") {
      setShowConfirmPassword(!showConfirmPassword);
    }
  };
  const handleCancel = () => {
    setCurrentPassword("");
    setNewPassword("");
    setConfirmPassword("");
    setShowCurrentPassword(false);
    setShowNewPassword(false);
    setShowConfirmPassword(false);
  };

  const submitHandler = async (e) => {
    e.preventDefault();
    // if (currentPassword) {
    if (newPassword === confirmPassword) {
      await axios
        .post(
          environment.apiUrl + "auth/changePassword",
          { currentPassword: currentPassword, newPassword: newPassword },
          {
            headers: {
              "X-Authorization": "Bearer " + localStorage.getItem("token"),
            },
          }
        )
        .then((res) => {
          if (res.response?.data?.message) {
            MySwal.fire({
              title: <p>{res.response.data.message}</p>,
              type: "success",
            });
          } else {
            MySwal.fire({
              title: <p>Password has been changed successfully</p>,
              type: "success",
            });
            handleCancel();
            localStorage.setItem("token", res.data.token);
            localStorage.setItem("refreshToken", res.data.refreshToken);
          }
        })
        .catch((err) => {
          MySwal.fire({
            title: <p>{err?.response?.data?.message || "Failed"}</p>,
            type: "error",
          });
        });
    } else {
      MySwal.fire({
        title: <p>Passwords Don't match</p>,
        type: "error",
      });
    }
    // } else {
    //   MySwal.fire({
    //     title: <p>Please enter your password</p>,
    //     type: "error",
    //   });
    // }

    // axios
    //   .post(
    //     environment.apiUrl + "auth/changePassword",
    //     { currentPassword: currentPassword, newPassword: newPassword },
    //     {
    //       headers: {
    //         "X-Authorization": "Bearer " + localStorage.getItem("token"),
    //       },
    //     }
    //   )
    //   .then(() => {
    //     console.log("password changed");
    //     MySwal.fire({
    //       title: <p>Password has been changed successfully</p>,
    //       type: "success",
    //     });
    //     window.alert("password changed");
    //   })
    //   .catch((err) => {
    //     MySwal.fire({
    //       title: <p>{err.message}</p>,
    //       type: "error",
    //     });
    //     console.log("error in changing password");
    //   });
  };
  var fullName = "";
  // var dap_email = "";
  const userDetailss = JSON.parse(localStorage.getItem("userDetails"));
  useEffect(() => {
    fullName = userDetailss.data.firstName + " " + userDetailss.data.lastName;
    var dap_email = userDetailss.data.email;
    console.log(dap_email);
    setUserDetails({
      name: fullName,
      email: userDetailss.data.email,
      authority: userDetailss.data.authority,
    });
    getUserDetails();
    setLoader(false);
    const time = new Date().getHours();

    if (time >= 5 && time < 12) {
      setGreeting("Morning");
    } else if (time >= 12 && time < 18) {
      setGreeting("Afternoon");
    } else {
      setGreeting("Evening");
    }
  }, []);
  const getUserDetails = async () => {
    // e.preventDefault()
    const userLocal = JSON.parse(localStorage.getItem("user"))
    await axios
      .get(environment.dap_url + "users/" + userLocal._id)
      .then((res) => {
        console.log("om your response is here -----------------",res.data);
        let profile_url = res.data.profileImageUrl;
        if (res.data.profileImageUrl) {
          setProfilePicUrl(environment.dap_imageUrl + profile_url);
        } else {
          setProfilePicUrl("../../assets/images/useravatar.png");
        }
        setMobile(res.data.phone);
        setAddress(res.data.address);
        setUserInfo({
          address: res.data.address,
          city: res.data.city,
          country: res.data.country,
          email: res.data.email,
          state: res.data.state,
          userFirstName: res.data.userFirstName,
          userId: res.data.userId,
          userLastName: res.data.userLastName,
          userFirstName: res.data.userFirstName,
          userName: res.data.userName,
          userNumber: res.data.userNumber,
          zip: res.data.zip,
          isBilable: res.data.isBillable,
          package:res.data.package,
          joindate:res.data.createdAt,
          organization:res.data.organization,
        });
      })
      .catch((err) => {
        window.alert(err.message);
      });
  };

  // const Greeting = () => {
  //   const [greeting, setGreeting] = useState('');

  //   useEffect(() => {
  //       // history.push('#dashboard')
  //       // console.log("history",history);

  //       const time = new Date().getHours();

  //       if (time >= 5 && time < 12) {
  //           setGreeting('Morning');
  //       } else if (time >= 12 && time < 18) {
  //           setGreeting('Afternoon');
  //       } else {
  //           setGreeting('Evening');
  //       }
  //   }, []);

  //   return (
  //       { greeting }
  //   );
  // };

  // var time = new Date();
  // var Greetings = "Morning";
  // var UserName = "Sidhartha";
  // var Device = "10";

  // render() {
  return loader ? (
    <Loader />
  ) : (
    <div>
      <div
        className="Header"
        style={{ display: "flex", flexDirection: "right" }}
      >
        <div id="CustomerPhoto">
          <img
            className="header-image"
            src="https://picsum.photos/200/300"
            alt="Header Image"
          />
        </div>
        <div
          style={{
            display: "flex",
            flexDirection: "column",
            margin: "30px 35px",
          }}
        >
          <span id="dayTime">Good {greeting}!</span>
          <span id="Welcome">
            Welcome <sapn id="UserName">{userDetailss.data.firstName} !</sapn>
          </span>
        </div>
      </div>
      <div style={{ backgroundColor: "#fff" }}>
        <Tabs
          // defaultActiveKey="dashboard"
          activeKey={key}
          id="uncontrolled"
          onSelect={(k) => setKey(k)}
          className="mb-3"
        >
          <Tab eventKey="Profile" title="Profile">
            <div className="card">
              <div className="col-md-12">
                <div className="row">
                  <div className="col-md-12">
                    <div className="row">
                      {/* Left side: AirBubble Text */}
                      <div className="col-md-6">
                        <div style={{ marginTop: "20px", marginLeft: "10px" }}>
                          <p
                            style={{
                              fontSize: "14px",
                              color: "#333333",
                              fontFamily: "Roboto",
                            }}
                          >
                            <b>AirBubble</b> is a subscription service that combines Japanese air
                            purification system and IAQ monitoring by a reliable and tested IoT device.
                            AirBubble is powered by a superlative and seamless service where we take care
                            of all end-to-end solution implementation and delivery. The monitoring data
                            is also available through an android/IOS app.
                            <br />
                            <br />
                            We strive to improve it continuously and thus from time to time would seek your feedback.
                            <br />
                            <br />
                            Enjoy clean air!
                          </p>
                        </div>
                      </div>

                      {/* Right side: Image and Details */}
                      <div className="col-md-6">
                        <div className="row">
                          <div style={{ marginLeft: "15px" }}>
                            <img
                              width="180px"
                              height="180px"
                              src="https://thumbs.dreamstime.com/b/businessman-avatar-image-beard-hairstyle-male-profile-vector-illustration-178545831.jpg"
                              alt=""
                            />
                          </div>
                          <div style={{ marginTop: "20px" }}>
                            <div
                              style={{
                                marginTop: "10px",
                                fontFamily: "Roboto",
                                fontSize: "16px",
                              }}
                              className="row"
                            >
                              <b>
                                {userInfo.organization && userInfo.organization.trim() !== "" ? userInfo.organization : ""}
                              </b>
                            </div>
                            <div
                              style={{
                                marginTop: "10px",
                                fontFamily: "Roboto",
                                fontSize: "14px",
                                color: "#8A93A3",
                              }}
                              className="row"
                            >
                            {userDetailss.data.firstName + " " + userDetailss.data.lastName}
                            </div>
                            <div
                              style={{
                                marginTop: "10px",
                                fontFamily: "Roboto",
                                fontSize: "14px",
                                color: "#8A93A3",
                              }}
                              className="row"
                            >
                              {userDetailss.data.email}
                            </div>
                            <div
                              style={{
                                marginTop: "10px",
                                fontFamily: "Roboto",
                                fontSize: "14px",
                                color: "#8A93A3",
                              }}
                              className="row"
                            >
                              {/* {userDetailss.data.DOB ? userDetailss.data.DOB : "10-09-1997"} */}
                              {new Date(userInfo.joindate).toLocaleDateString('en-GB')}
                            </div>
                            <div
                              style={{
                                marginTop: "10px",
                                fontFamily: "Roboto",
                                fontSize: "14px",
                                color: "#8A93A3",
                              }}
                              className="row"
                            >
                              <p>Subscription Plan : {userInfo.isBilable ? (userInfo.package || "Platinum") : "Platinum"}</p>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>

                  {/* <div className="col-md-6">
                    <div
                      style={{
                        marginTop: "20px",
                      }}
                    >
                      <h5>
                        <b>Write to us About your Experience</b>
                      </h5> 
                    </div>
                    <div>
                      <textarea
                        name=""
                        id=""
                        cols="61"
                        rows="10"
                        placeholder="  Let us hear from you..... "
                        style={{
                          backgroundColor: "#F5F5F5",
                          border: "0.005px solid white",
                        }}
                        value={textareaValue}
                        onChange={handleTextareaChange}
                      ></textarea>
                      <div
                        style={{
                          marginTop: "10px",
                          marginBottom: "10px",
                          marginLeft: "435px",
                        }}
                      >
                        <button
                          type="button"
                          class="btn btn-primary btn-lg"
                          style={{ marginLeft: "-90px" }}
                          onClick={sendmail}
                        >
                          Send
                        </button>
                      </div>
                    </div>
                  </div> */}
                </div>
              </div>
            </div>
          </Tab>
          <Tab eventKey="Change Password" title="Change Password">
            <div className="row">
              <div className="col-lg-3"></div>
              <div className="col-md-6 grid-margin stretch-card">
                <div className="card">
                  <div className="card-body">
                    <Form onSubmit={submitHandler}>
                      <Form.Group controlId="title">
                        <Form.Label>
                          * <b>Current Password</b>
                        </Form.Label>
                        <InputGroup>
                          <Form.Control
                            type={showCurrentPassword ? "text" : "password"}
                            placeholder="Enter current password"
                            value={currentPassword}
                            onChange={(e) => setCurrentPassword(e.target.value)}
                          />
                          <InputGroup.Append>
                            <InputGroup.Text
                              onClick={() =>
                                togglePasswordVisibility("currentPassword")
                              }
                            >
                              <FontAwesomeIcon
                                icon={showCurrentPassword ? faEye : faEyeSlash}
                              />
                            </InputGroup.Text>
                          </InputGroup.Append>
                        </InputGroup>
                      </Form.Group>

                      <Form.Group
                        controlId="name"
                        style={{ marginTop: "50px" }}
                      >
                        <Form.Label>
                          * <b>Set New Password</b>
                        </Form.Label>
                        <InputGroup>
                          <Form.Control
                            type={showNewPassword ? "text" : "password"}
                            placeholder="Enter New Password"
                            value={newPassword}
                            onChange={(e) => setNewPassword(e.target.value)}
                          />
                          <InputGroup.Append>
                            <InputGroup.Text
                              onClick={() =>
                                togglePasswordVisibility("newPassword")
                              }
                            >
                              <FontAwesomeIcon
                                icon={showNewPassword ? faEye : faEyeSlash}
                              />
                            </InputGroup.Text>
                          </InputGroup.Append>
                        </InputGroup>
                      </Form.Group>

                      <Form.Group
                        controlId="name"
                        style={{ marginTop: "50px" }}
                      >
                        <Form.Label>
                          * <b>Re-enter New Password</b>
                        </Form.Label>
                        <InputGroup>
                          <Form.Control
                            type={showConfirmPassword ? "text" : "password"}
                            placeholder="Enter Password Again"
                            value={confirmPassword}
                            onChange={(e) => setConfirmPassword(e.target.value)}
                          />
                          <InputGroup.Append>
                            <InputGroup.Text
                              onClick={() =>
                                togglePasswordVisibility("confirmPassword")
                              }
                            >
                              <FontAwesomeIcon
                                icon={showConfirmPassword ? faEye : faEyeSlash}
                              />
                            </InputGroup.Text>
                          </InputGroup.Append>
                        </InputGroup>
                      </Form.Group>
                      <div
                        className="row col-md-12 mt-10"
                        style={{ marginTop: "50px" }}
                      >
                        <div className="col-md-6">
                          <Button
                            type="submit"
                            className="btn btn-block btn-primary btn-lg font-weight-medium auth-form-btn"
                          >
                            Update Change
                          </Button>
                        </div>
                        <div className="col-md-6">
                          <Button
                            className="btn btn-block btn-light btn-lg font-weight-medium auth-form-btn"
                            onClick={handleCancel}
                          >
                            Cancel
                          </Button>
                        </div>
                      </div>
                    </Form>
                  </div>
                </div>
              </div>
              <div className="col-lg-3"></div>
            </div>
          </Tab>
          <Tab eventKey="account" title="Accounts" id="alertTab">
            <Row>
              <Col className="profile-account col-l">
                {/* <div> */}
                <img
                  src="/assets/images/DAP_logo2.png"
                  className="image"
                  alt=""
                />
                <div className="subscription-box">
                  <h3>
                    <b>{userInfo.isBilable ? (userInfo.package || "Platinum") : "Platinum"} Plan</b>
                  </h3>
                  {/* <Button className="btn btn-light my-3">Cancel Renewal</Button> */}
                </div>
                <div className="info">
                  <ul>
                    <li>
                      <b>
                        Your current rate is{" "}Re.
                        <span className="primary-color">1  </span>per cu.ft.
                      </b>
                    </li>
                    <li>
                      <b>Your payment will automatically renewed each month</b>
                    </li>
                  </ul>
                </div>
                <div className="subscription-box" style={{ border: "none" }}>
                  <h3>
                    {/* <b>Invoicing</b> */}
                  </h3>
                  <a className="primary-color" href="#">
                    {/* Check billing history */}
                  </a>
                </div>
                {/* </div> */}
              </Col>
              <Col className="profile-account col-r">
                <h2 style={{ paddingBottom: "10px", marginBottom: "10px" }}>
                  {/* <b>Billing Information</b>{" "} */}
                  {/* <Button variant="warning" size="sm">
                    <i className="fa fa-edit "></i> Edit
                  </Button> */}
                </h2>
                <div>
                  <Row className="user-info">
                    <Col
                      className="info-l"
                      md="auto"
                      style={{
                        color: "#8A9383",
                        fontWeight: "500",
                        fontSize: "14px",
                      }}
                    >
                      <p>Organization Name</p>
                      <p>Customer First Name</p>
                      <p>Customer Last Name</p>
                      <p>Email</p>
                      <p>Address</p>
                      <p>Country</p>
                      <p>State/Region</p>
                      <p>City</p>
                      <p>Zip code</p>
                    </Col>
                    <Col
                      className="info-r"
                      style={{
                        color: "#333333",
                        fontWeight: "500",
                        fontSize: "14px",
                      }}
                    >
                      <p>{userInfo.organization}</p>
                      <p>{userInfo.userFirstName}</p>
                      <p>{userInfo.userLastName}</p>
                      <p>{userInfo.email}</p>
                      <p>{userInfo.address}</p>
                      <p>{userInfo.country}</p>
                      <p>{userInfo.state}</p>
                      <p>{userInfo.city}</p>
                      <p>{userInfo.zip}</p>
                    </Col>
                  </Row>
                </div>
                {/* <Button
                  style={{
                    backgroundColor: "#5271ff",
                    position: "absolute",
                    bottom: 0,
                    right: "30px",
                  }}
                >
                  Save Changes
                </Button> */}
              </Col>
            </Row>
          </Tab>
        </Tabs>
      </div>
    </div>
    // <div>
    //   <div className="row">
    //     <div className="col-3"></div>
    //     <div className="col-6">
    //       <div className="card">
    //         <div className="card-body" style={{ paddingTop: "7%" }}>
    //           <div className="border-bottom text-center pb-4">
    //             <img
    //               src={dap_profilePicUrl}
    //               alt="profile"
    //               className="img-lg rounded-circle mb-3"
    //             />
    //             <div className="mb-3">
    //               <h3>{dap_userName.name}</h3>
    //               <div className="d-flex align-items-center justify-content-center">
    //                 <h5 className="mb-0 mr-2 text-muted">
    //                   {dap_userName.email}
    //                 </p>
    //               </div>
    //             </div>

    //             <div>
    //               <p className="clearfix">
    //                 <span className="float-left">Role</span>
    //                 <span className="float-right text-muted">
    //                   {" "}
    //                   {/* {userDetails.data.authority}{" "} */}
    //                   {dap_userName.authority}
    //                 </span>
    //               </p>
    //               <p className="clearfix">
    //                 <span className="float-left">E mail</span>
    //                 <span className="float-right text-muted">
    //                   {/* {userDetails.data.email} */}
    //                   {dap_userName.email}
    //                 </span>
    //               </p>
    //               <p className="clearfix">
    //                 <span className="float-left">Phone</span>
    //                 <span className="float-right text-muted">
    //                   {" "}
    //                   {dap_mobile}{" "}
    //                 </span>
    //               </p>

    //               <p className="clearfix">
    //                 <span className="float-left">Address</span>
    //                 <span className="float-right text-muted">
    //                   {" "}
    //                   {/* {userDetails.data.authority}{" "} */}
    //                   {dap_address}
    //                 </span>
    //               </p>
    //             </div>

    //             <button
    //               className="btn btn-success btn-block mb-2 "
    //               onClick={() => push("/user/profile")}
    //               style={{ wordWrap: "break-word" }}
    //             >
    //               Edit Profile
    //             </button>

    //             <button
    //               className="btn btn-primary btn-block mb-2"
    //               onClick={() => push("/user/changePassword")}
    //               style={{ wordWrap: "break-word" }}
    //             >
    //               Change Password
    //             </button>
    //           </div>
    //         </div>
    //       </div>
    //     </div>
    //     <div className="col-3"></div>
    //   </div>
    // </div>
  );
};

export default UserProfile;
